import { getUnixTime } from 'date-fns';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import {
  DATE_RANGE_TYPES,
  getActiveDateRange,
} from 'dashboard/components/ui/DatePicker/helpers/DatePickerHelper';

const getAccountStore = accountId =>
  LocalStorage.getFromJsonStore(
    LOCAL_STORAGE_KEYS.REPORT_FILTERS,
    String(accountId)
  ) || {};

// Named presets (last7days and friends) are stored as of the day they were
// applied, so recalculate them against today before restoring.
const refreshDateRange = query => {
  const { range } = query;
  if (!range || range === DATE_RANGE_TYPES.CUSTOM_RANGE) return query;

  const { start, end } = getActiveDateRange(range, new Date());
  return {
    ...query,
    from: String(getUnixTime(start)),
    to: String(getUnixTime(end)),
  };
};

export const saveReportQuery = (accountId, routeName, query) => {
  if (!accountId || !routeName || !Object.keys(query || {}).length) return;

  LocalStorage.updateJsonStore(
    LOCAL_STORAGE_KEYS.REPORT_FILTERS,
    String(accountId),
    { ...getAccountStore(accountId), [routeName]: query }
  );
};

export const getSavedReportQuery = (accountId, routeName) => {
  if (!accountId || !routeName) return null;

  const query = getAccountStore(accountId)[routeName];
  if (!query || !Object.keys(query).length) return null;

  return refreshDateRange(query);
};
